import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-line-event-engagement-rate',
  templateUrl: './line-event-engagement-rate.component.html',
  styleUrl: './line-event-engagement-rate.component.scss',
})
export class LineEventEngagementRateComponent {
  isLoading = true;
  options: echarts.EChartsOption = {
    legend: {
      show: false,
    },
    yAxis: {
      axisLabel: {
        formatter: '{value}%', // append percentage sign to labels
      },
    },

    grid: { left: 40, right: 35, top: 40, bottom: 40 },
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.lineEventEngagementRate$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('lineEventEngagementRate');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getLineEventEngagementRate().subscribe();
  }

  get series() {
    return this.analyticsService.lineEventEngagementRate$.value?.series;
  }

  get labels() {
    return this.analyticsService.lineEventEngagementRate$.value?.labels;
  }
}
